export * from '/components/activity-registration/components/ActivityRegistration';
